import * as React from 'react';
import PropTypes from 'prop-types';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import {
  NotificationModalDismissButton,
  useNotificationModalContext
} from 'catering/context/providers/NotificationModalProvider';
import {
  ModalDialogContent,
  NotificationModalCloseButton
} from 'catering/components/Modals';
import StyledDialogTitle from 'components/StyledDialogTitle';
import StyledDialogContentText from 'components/StyledDialogContentText';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';

const StyledDialogTitleWithMargin = styled(StyledDialogTitle)(({ theme }) => {
  return {
    marginBottom: 10
  };
});

const StyledDialogActions = styled(DialogActions)({
  textAlign: 'center'
});

export function NotificationModal({ text, children, title }) {
  const titleStyles = { variant: MENU_ITEM_NAMES };
  const bodyStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <ModalDialogContent
      sx={{
        '&.MuiDialogContent-root': {
          padding: '20px'
        }
      }}
    >
      <NotificationModalDismissButton>
        <NotificationModalCloseButton />
      </NotificationModalDismissButton>
      <StyledDialogTitleWithMargin {...titleStyles}>
        {title}
      </StyledDialogTitleWithMargin>
      <StyledDialogContentText {...bodyStyles}>{text}</StyledDialogContentText>
      <StyledDialogActions>{children}</StyledDialogActions>
    </ModalDialogContent>
  );
}

NotificationModal.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export function useOpenNotificationModal(ContentElement) {
  const { setIsOpen, setContent } = useNotificationModalContext();
  return props => {
    setContent(
      React.cloneElement(ContentElement, {
        ...props
      })
    );
    setIsOpen(true);
  };
}

export function useCloseNotificationModal() {
  const { setIsOpen } = useNotificationModalContext();
  return () => {
    setIsOpen(false);
  };
}
